import { UIText3 } from '@cian/ui-kit';
import * as React from 'react';

import * as styles from './NewbuildingServicesList.css';
import { trackNewbuildingEntryPointClick } from './tracking';
import { INewbuildingService } from '../../types/newbuildingService';

export interface INewbuildingServicesListProps {
  services?: INewbuildingService[];
}

export const NewbuildingServicesList: React.FC<INewbuildingServicesListProps> = ({ services }) => {
  /* istanbul ignore next */
  if (!services) {
    return null;
  }

  return (
    <div className={styles['container']} data-testid="NewbuildingServicesList">
      {services.map(service => (
        <a
          key={service.type}
          data-testid={`NewbuildingServiceLink-${service.type}`}
          href={service.url}
          className={styles['link']}
          onClick={() => trackNewbuildingEntryPointClick(service.type)}
        >
          <img className={styles['image']} src={service.iconUrl} alt={service.title} />
          <UIText3 textAlign="center" as="span">
            {service.title}
          </UIText3>
        </a>
      ))}
    </div>
  );
};
